import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { AuditLogPage } from '../../features/audit/audit-log-page'
import { auditSearchSchema } from '../../features/audit/search'

export const Route = createFileRoute('/_app/audit-log')({
  staticData: { crumb: 'auditLog' },
  validateSearch: auditSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'audit.read'),
  component: AuditLogPage,
})
